


function showShopMenu(){
  let toggle = document.querySelector('#shopToggle');
  toggle.classList.remove('toggledOff')
  toggle.classList.add('toggledOn')
  
  // adjust the translation of the page
  let body = document.querySelector('#app-body-inner');
  body.classList.remove('up');
  body.classList.add('down');
  
  
  localStorage.setItem('shopMenuToggle', 1);
  console.log('shopMenuToggleShow', localStorage.getItem('shopMenuToggle'));
}

function hideShopMenu(){
  // hide the shopMenu
  let toggle = document.querySelector('#shopToggle');
  toggle.classList.remove('toggledOn');
  toggle.classList.add('toggledOff');
  
  // adjust the translation of the page
  let body = document.querySelector('#app-body-inner');
  body.classList.remove('down');
  body.classList.add('up');
  
  
  localStorage.setItem('shopMenuToggle', 0);
  console.log('shopMenuToggleHide', localStorage.getItem('shopMenuToggle'));  
}

function toggleShopMenu(){
  console.log('toggled');
  var toggle = document.getElementById('shopToggle');
  if(toggle.classList.contains('toggledOn'))
    hideShopMenu(toggle);
  else
    showShopMenu(toggle);    
}


function initShopMenuToggling(){
  var toggle = document.querySelector('#shopToggle span');
    toggle.addEventListener('click', toggleShopMenu);
    console.log('shopMenuToggleReady', localStorage.getItem('shopMenuToggle'));
    let show = localStorage.getItem('shopMenuToggle')
    if(show == 1)
      showShopMenu()
    else
      hideShopMenu();
}

function initBodyOffset(){
 // this function makes sure the entire page body is visible, given the shopMenu may be toggled and overlapping it if the page is not translated vertically down
 
  
}

function Image_Popup_Show(e, o, t, s) {
    var n = new Image;
  	console.log('show image', e);
  	//e = 'https://synthesizers.com/'+e;
    n.src = e,
    n.onload = function() {
        void 0 === o && (o = 0),
        isNaN(o) && (o = 0),
        void 0 === t && (t = 0),
        isNaN(t) && (t = 0),
        0 === o ? 0 === t ? (o = n.width + 20,
        t = n.height + 15) : (o = parseInt(t * (n.width / n.height), 10),
        t += 15) : 0 === t ? (o += 20,
        t = parseInt(o * (n.height / n.width), 10)) : (o += 20,
        t += 15),
        document.getElementById("Image_Popup").innerHTML = '<span onclick="Image_Popup_Hide();">Close X<br></span><img id="thepopupimage" onclick="Image_Popup_Hide();" src="' +  e + '">',
        "inline" !== document.getElementById("Image_Popup").style.display && (x = document.getElementById("Image_Popup").parentElement.offsetWidth / 2 - o / 2,
        x < 50 && (x = 50),
        document.getElementById("Image_Popup").style.left = x + "px",
        y = document.documentElement.scrollTop,
        0 === y && (y = document.body.scrollTop),
        y += 300,
        o -= 20,
        t -= 20,
        document.getElementById("Image_Popup").style.top = y + "px",
        document.getElementById("thepopupimage").style.width = "unset",
        document.getElementById("thepopupimage").style.height = t+"px"),
        document.getElementById("Image_Popup").style.display = "inline",
        document.getElementById("Image_Popup").focus()
        //document.getElementById("thepopupimage").style.width = o + "px",
        //document.getElementById("thepopupimage").style.height = "unset"),
    }
    ,
    0 === n.width && Image_Popup_Hide()
  
}

function Image_Popup_Hide(src){
  var imgPopup = document.querySelector('#Image_Popup');
  imgPopup.style.display="none";
  var thepopupimage = document.querySelector('#thepopupimage');
  thepopupimage.src = "";
//'/products/systems/qcf22/tb22_frontopen_1000.jpg',0,0);
}

function drag_start(e) {
    var o = window.getComputedStyle(e.target, null);
    e.dataTransfer.setData("text/plain", parseInt(o.getPropertyValue("left"), 10) - e.clientX + "," + (parseInt(o.getPropertyValue("top"), 10) - e.clientY))
}
function drag_over(e) {
    return e.preventDefault(),
    !1
}
function drop(e) {
    var o = e.dataTransfer.getData("text/plain").split(",")
      , t = document.getElementById("Image_Popup");
    return t.style.left = e.clientX + parseInt(o[0], 10) + "px",
    t.style.top = e.clientY + parseInt(o[1], 10) + "px",
    e.preventDefault(),
    !1
}


!function($) {

  // Add custom JavasScript here
  // --------------------------

  


  // Document ready
  $(function() {

    console.log('doc ready');
    initShopMenuToggling();
    document.getElementById("Image_Popup").addEventListener("dragstart", drag_start, !1),
    document.body.addEventListener("dragover", drag_over, !1),
    document.body.addEventListener("drop", drop, !1),
    
    initBodyOffset();
    

  });

}(jQuery);

